import { Commit } from "vuex";
import { http } from "../../plugins/axios";

export interface RetirementState {}

const state = (): RetirementState => ({});

const mutations = {};

const getters = {};

const actions = {
  async createRetirementApplication({ commit }: { commit: Commit }, data: any) {
    const endpoint = "/application/retirement";

    const res = await http.post(endpoint, data);

    return res.data;
  },
  async getRetirementTypes() {
    const endpoint = "/application/retirement/types";

    const res = await http.get(endpoint);

    return res.data;
  },
  async getRetirementDateTypes() {
    const endpoint = "/application/retirement/date-types";

    const res = await http.get(endpoint);

    return res.data;
  },
  async getEffectiveDates() {
    const endpoint = "/application/retirement/effective-dates";

    const res = await http.get(endpoint);

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
